import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

// Attach admin token if present
http.interceptors.request.use((config) => {
  const token = localStorage.getItem("sq_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

// ---------- Public ----------
export const fetchArticles = async (params = {}) => (await http.get("/articles", { params })).data;
export const fetchArticle = async (slug) => (await http.get(`/articles/${slug}`)).data;
export const fetchComunicazioni = async (sub) =>
  (await http.get("/comunicazioni", { params: sub ? { sub } : {} })).data;
export const fetchComunicazione = async (sub, slug) =>
  (await http.get(`/comunicazioni/${sub}/${slug}`)).data;
export const fetchSocieta = async (params = {}) => (await http.get("/societa", { params })).data;
export const fetchMarketIndices = async () => (await http.get("/market-indices")).data;
export const fetchBanners = async (slot) =>
  (await http.get("/banners", { params: slot ? { slot } : {} })).data;
export const fetchBilanci = async () => (await http.get("/bilanci")).data;
export const fetchTrasparenza = async () => (await http.get("/trasparenza")).data;
export const fetchBilancio = async (ticker) => (await http.get(`/bilanci/${ticker}`)).data;
export const adminListBilanci = async () => (await http.get("/admin/bilanci")).data;
export const adminCreateBilancio = async (body) => (await http.post("/admin/bilanci", body)).data;
export const adminUpdateBilancio = async (id, body) => (await http.put(`/admin/bilanci/${id}`, body)).data;
export const adminDeleteBilancio = async (id) => (await http.delete(`/admin/bilanci/${id}`)).data;

// ---------- Auth ----------
export const login = async (email, password) =>
  (await http.post("/auth/login", { email, password })).data;
export const fetchMe = async () => (await http.get("/auth/me")).data;
export const changePassword = async (current_password, new_password) =>
  (await http.post("/auth/change-password", { current_password, new_password })).data;

// ---------- Uploads ----------
export const uploadFile = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await http.post("/admin/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { url, filename }
};

// Chunked upload for large files (video). onProgress(0..1).
export const uploadFileChunked = async (file, onProgress) => {
  const chunkSize = 5 * 1024 * 1024; // 5MB
  const total = Math.max(1, Math.ceil(file.size / chunkSize));
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunkSize, (i + 1) * chunkSize);
    const form = new FormData();
    form.append("upload_id", uploadId);
    form.append("chunk_index", String(i));
    form.append("file", blob, "chunk");
    await http.post("/admin/upload/chunk", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (onProgress) onProgress((i + 1) / total);
  }
  const completeForm = new FormData();
  completeForm.append("upload_id", uploadId);
  completeForm.append("total_chunks", String(total));
  completeForm.append("filename", file.name);
  const { data } = await http.post("/admin/upload/complete", completeForm, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { url, filename }
};

// ---------- AI ----------
export const generateDraft = async (payload) =>
  (await http.post("/admin/generate-draft", payload)).data;

// ---------- Admin: Articles ----------
export const adminListArticles = async () => (await http.get("/admin/articles")).data;
export const adminCreateArticle = async (body) => (await http.post("/admin/articles", body)).data;
export const adminUpdateArticle = async (id, body) =>
  (await http.put(`/admin/articles/${id}`, body)).data;
export const adminDeleteArticle = async (id) => (await http.delete(`/admin/articles/${id}`)).data;

// ---------- Admin: Comunicazioni ----------
export const adminListComunicazioni = async () => (await http.get("/admin/comunicazioni")).data;
export const adminCreateComunicazione = async (body) =>
  (await http.post("/admin/comunicazioni", body)).data;
export const adminUpdateComunicazione = async (id, body) =>
  (await http.put(`/admin/comunicazioni/${id}`, body)).data;
export const adminDeleteComunicazione = async (id) =>
  (await http.delete(`/admin/comunicazioni/${id}`)).data;

// ---------- Admin: Banners ----------
export const adminListBanners = async () => (await http.get("/admin/banners")).data;
export const adminCreateBanner = async (body) => (await http.post("/admin/banners", body)).data;
export const adminUpdateBanner = async (id, body) =>
  (await http.put(`/admin/banners/${id}`, body)).data;
export const adminDeleteBanner = async (id) => (await http.delete(`/admin/banners/${id}`)).data;

// ---------- Admin: RSS Feeds ----------
export const adminListFeeds = async () => (await http.get("/admin/feeds")).data;
export const adminCreateFeed = async (body) => (await http.post("/admin/feeds", body)).data;
export const adminUpdateFeed = async (id, body) => (await http.put(`/admin/feeds/${id}`, body)).data;
export const adminDeleteFeed = async (id) => (await http.delete(`/admin/feeds/${id}`)).data;
export const adminImportFeeds = async () => (await http.post("/admin/feeds/import")).data;
export const adminImportStatus = async () => (await http.get("/admin/feeds/import-status")).data;

export default http;
